(function () {
  if (window.__hoverSlideshowGalleryScriptLoaded) return;
  window.__hoverSlideshowGalleryScriptLoaded = true;

  function addMediaChangeListener(mediaQuery, handler) {
    if (!mediaQuery) return;

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handler);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handler);
    }
  }

  function initHoverSlideshowGallery(container) {
    if (!container || container.dataset.hsInit === 'true') return;

    const track = container.querySelector('[data-hover-slideshow-track]');
    if (!track) return;

    container.dataset.hsInit = 'true';
    track.style.scrollBehavior = 'auto';

    const hoverFineMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    const coarseMedia = window.matchMedia('(pointer: coarse), (any-pointer: coarse)');
    const noHoverMedia = window.matchMedia('(hover: none), (any-hover: none)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let rafId = null;
    let lastTime = null;
    let isAnimating = false;

    let loopWidth = 0;
    let position = 0;

    let resizeTimer = null;
    let resumeTimer = null;
    let wheelIdleTimer = null;
    let programmaticScrollDepth = 0;

    let touchStartX = 0;
    let touchStartY = 0;
    let suppressClickUntil = 0;

    let isPointerDown = false;
    let isDragging = false;
    let dragPointerId = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartPosition = 0;
    let dragStartScrollLeft = 0;

    let isTouchInteracting = false;
    let isWheelInteracting = false;

    function isDesktopHoverMode() {
      return hoverFineMedia.matches && !reduceMotion.matches;
    }

    function isTouchAutoplayMode() {
      return !hoverFineMedia.matches && (coarseMedia.matches || noHoverMedia.matches) && !reduceMotion.matches;
    }

    function getRealItems() {
      return Array.from(track.children).filter(function (item) {
        return item.getAttribute('data-hs-clone') !== 'true';
      });
    }

    function clearClones() {
      track.querySelectorAll('[data-hs-clone="true"]').forEach(function (node) {
        node.remove();
      });
    }

    function cleanCloneTree(root) {
      const attrsToRemove = [
        'id',
        'data-shopify-editor-block',
        'data-shopify-editor-block-id',
        'data-block-id'
      ];

      function stripAttrs(node) {
        attrsToRemove.forEach(function (attr) {
          if (node.hasAttribute && node.hasAttribute(attr)) {
            node.removeAttribute(attr);
          }
        });
      }

      root.setAttribute('data-hs-clone', 'true');
      root.setAttribute('aria-hidden', 'true');
      stripAttrs(root);

      root.querySelectorAll('*').forEach(function (node) {
        stripAttrs(node);
      });

      root.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
        node.setAttribute('tabindex', '-1');
      });
    }

    function getDesktopSpeed() {
      const raw = parseFloat(container.dataset.hoverSpeed || '90');

      if (!Number.isFinite(raw)) return 90;

      return Math.max(20, Math.min(raw, 220));
    }

    function getTouchSpeed() {
      const raw = parseFloat(container.dataset.mobileSpeed || '55');

      if (!Number.isFinite(raw)) return 55;

      return Math.max(10, Math.min(raw, 160));
    }

    function getActiveSpeed() {
      return isTouchAutoplayMode() ? getTouchSpeed() : getDesktopSpeed();
    }

    function normalizePosition(value) {
      if (!loopWidth || loopWidth <= 0) return 0;

      let next = value % loopWidth;
      if (next < 0) next += loopWidth;
      return next;
    }

    function setProgrammaticScroll(nextLeft) {
      programmaticScrollDepth += 1;
      track.scrollLeft = nextLeft;

      requestAnimationFrame(function () {
        programmaticScrollDepth = Math.max(0, programmaticScrollDepth - 1);
      });
    }

    function setAutoplayClass(active) {
      track.classList.toggle('is-autoplaying', !!active);
    }

    function setTouchingClass(active) {
      track.classList.toggle('is-touching', !!active);
    }

    function setUserScrollingClass(active) {
      track.classList.toggle('is-user-scrolling', !!active);
    }

    function shouldAutoplayNow() {
      if (reduceMotion.matches || loopWidth <= 0) return false;
      if (isPointerDown || isDragging || isTouchInteracting || isWheelInteracting) return false;

      if (isTouchAutoplayMode()) {
        return true;
      }

      return isDesktopHoverMode() && container.matches(':hover');
    }

    function clearResume() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume(delay) {
      clearResume();

      if (reduceMotion.matches || loopWidth <= 0) return;
      if (isPointerDown || isDragging || isTouchInteracting || isWheelInteracting) return;

      if (!isTouchAutoplayMode() && !(isDesktopHoverMode() && container.matches(':hover'))) {
        return;
      }

      resumeTimer = window.setTimeout(function () {
        if (shouldAutoplayNow()) {
          startAnimation();
        }
      }, typeof delay === 'number' ? delay : (isTouchAutoplayMode() ? 1300 : 900));
    }

    function syncPosition() {
      if (!loopWidth || loopWidth <= 0) return;

      position = normalizePosition(position);
      setProgrammaticScroll(position);
    }

    function stopAnimation() {
      isAnimating = false;
      lastTime = null;
      setAutoplayClass(false);

      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function wrapNativeScrollPosition(rawValue) {
      if (!loopWidth || loopWidth <= 0) return rawValue;

      if (rawValue >= loopWidth) {
        return normalizePosition(rawValue);
      }

      if (rawValue < 0) {
        return normalizePosition(rawValue);
      }

      return rawValue;
    }

    function rebuildTrack(preservePosition) {
      const previousPosition = loopWidth > 0 ? normalizePosition(position || track.scrollLeft || 0) : (track.scrollLeft || 0);

      stopAnimation();
      clearResume();
      clearClones();

      const realItems = getRealItems();
      loopWidth = 0;
      position = 0;

      if (reduceMotion.matches || realItems.length < 2) {
        setProgrammaticScroll(0);
        return;
      }

      const baseWidth = track.scrollWidth;
      if (!baseWidth) return;

      let firstCloneStart = null;
      let passCount = 0;
      const minNeededWidth = baseWidth + (track.clientWidth * 2);

      while (track.scrollWidth < minNeededWidth && passCount < 8) {
        const fragment = document.createDocumentFragment();

        realItems.forEach(function (item, index) {
          const clone = item.cloneNode(true);
          cleanCloneTree(clone);

          if (!firstCloneStart && passCount === 0 && index === 0) {
            firstCloneStart = clone;
          }

          fragment.appendChild(clone);
        });

        track.appendChild(fragment);
        passCount += 1;
      }

      if (!firstCloneStart) return;

      loopWidth = firstCloneStart.offsetLeft - realItems[0].offsetLeft;

      if (!Number.isFinite(loopWidth) || loopWidth <= 0) {
        loopWidth = baseWidth;
      }

      position = preservePosition ? previousPosition : Math.min(track.scrollLeft || 0, Math.max(loopWidth - 1, 0));
      position = normalizePosition(position);
      setProgrammaticScroll(position);
    }

    function step(time) {
      if (!isAnimating) {
        rafId = null;
        return;
      }

      if (!shouldAutoplayNow()) {
        stopAnimation();
        scheduleResume();
        return;
      }

      if (lastTime === null) {
        lastTime = time;
      }

      const delta = Math.min((time - lastTime) / 1000, 0.032);
      lastTime = time;

      position += getActiveSpeed() * delta;
      syncPosition();

      rafId = requestAnimationFrame(step);
    }

    function startAnimation() {
      if (isAnimating) return;
      if (!shouldAutoplayNow()) return;

      clearResume();
      setTouchingClass(false);
      setUserScrollingClass(false);

      position = loopWidth > 0 ? normalizePosition(track.scrollLeft || position) : (track.scrollLeft || 0);
      isAnimating = true;
      setAutoplayClass(true);
      lastTime = null;
      rafId = requestAnimationFrame(step);
    }

    function queueRebuild(preservePosition) {
      clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        rebuildTrack(preservePosition);

        if (shouldAutoplayNow()) {
          startAnimation();
        }
      }, 80);
    }

    function removeDragListeners() {
      window.removeEventListener('pointermove', onWindowPointerMove);
      window.removeEventListener('pointerup', onWindowPointerUp);
      window.removeEventListener('pointercancel', onWindowPointerUp);
    }

    function endDrag(shouldResumeAfter) {
      const hadDragged = isDragging;

      isPointerDown = false;
      isDragging = false;
      dragPointerId = null;

      track.classList.remove('is-dragging');
      removeDragListeners();

      if (hadDragged) {
        suppressClickUntil = Date.now() + 350;
      }

      if (loopWidth > 0) {
        position = normalizePosition(track.scrollLeft || position);
      }

      if (shouldResumeAfter) {
        scheduleResume(isTouchAutoplayMode() ? 1300 : 900);
      }
    }

    function onWindowPointerMove(event) {
      if (!isPointerDown || event.pointerId !== dragPointerId) return;

      const deltaX = event.clientX - dragStartX;
      const deltaY = event.clientY - dragStartY;

      if (!isDragging) {
        if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

        isDragging = true;
        track.classList.add('is-dragging');
        suppressClickUntil = Date.now() + 350;
      }

      event.preventDefault();
      stopAnimation();
      clearResume();

      if (loopWidth > 0) {
        position = dragStartPosition - deltaX;
        syncPosition();
      } else {
        setProgrammaticScroll(dragStartScrollLeft - deltaX);
      }
    }

    function onWindowPointerUp(event) {
      if (!isPointerDown || event.pointerId !== dragPointerId) return;
      endDrag(true);
    }

    function onTrackPointerDown(event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('input, textarea, select, button')) return;

      stopAnimation();
      clearResume();
      setUserScrollingClass(true);

      isPointerDown = true;
      isDragging = false;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragStartPosition = loopWidth > 0 ? position : track.scrollLeft;
      dragStartScrollLeft = track.scrollLeft;

      window.addEventListener('pointermove', onWindowPointerMove, { passive: false });
      window.addEventListener('pointerup', onWindowPointerUp);
      window.addEventListener('pointercancel', onWindowPointerUp);
    }

    function markWheelInteraction() {
      stopAnimation();
      clearResume();
      isWheelInteracting = true;
      setUserScrollingClass(true);

      if (wheelIdleTimer) {
        clearTimeout(wheelIdleTimer);
      }

      wheelIdleTimer = window.setTimeout(function () {
        isWheelInteracting = false;
        scheduleResume(isTouchAutoplayMode() ? 1300 : 950);
      }, 180);
    }

    container.addEventListener('mouseenter', function () {
      if (isDesktopHoverMode()) {
        scheduleResume(80);
      }
    });

    container.addEventListener('mouseleave', function () {
      clearResume();
      setUserScrollingClass(false);

      if (!isTouchAutoplayMode()) {
        stopAnimation();
      }
    });

    track.addEventListener('pointerdown', onTrackPointerDown);

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener(
      'wheel',
      function () {
        markWheelInteraction();
      },
      { passive: true }
    );

    track.addEventListener(
      'touchstart',
      function (event) {
        stopAnimation();
        clearResume();
        isTouchInteracting = true;
        setTouchingClass(true);
        setUserScrollingClass(true);

        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;

        const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(event.touches[0].clientY - touchStartY);

        if (deltaX > 10 && deltaX > deltaY) {
          suppressClickUntil = Date.now() + 350;
        }

        clearResume();
      },
      { passive: true }
    );

    function handleTouchRelease() {
      isTouchInteracting = false;
      setTouchingClass(false);
      scheduleResume(1400);
    }

    track.addEventListener('touchend', handleTouchRelease, { passive: true });
    track.addEventListener('touchcancel', handleTouchRelease, { passive: true });

    track.addEventListener(
      'click',
      function (event) {
        if (Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    track.addEventListener(
      'scroll',
      function () {
        if (programmaticScrollDepth > 0) return;

        stopAnimation();
        clearResume();
        setUserScrollingClass(true);

        const raw = track.scrollLeft || 0;
        const wrapped = wrapNativeScrollPosition(raw);

        if (wrapped !== raw) {
          position = wrapped;
          setProgrammaticScroll(wrapped);
        } else {
          position = loopWidth > 0 ? normalizePosition(raw) : raw;
        }

        if (!isPointerDown && !isDragging && !isTouchInteracting && !isWheelInteracting) {
          scheduleResume(isTouchAutoplayMode() ? 1300 : 950);
        }
      },
      { passive: true }
    );

    track.addEventListener('focusin', function () {
      stopAnimation();
      clearResume();
    });

    track.addEventListener('focusout', function () {
      scheduleResume(isTouchAutoplayMode() ? 1300 : 900);
    });

    window.addEventListener('resize', function () {
      queueRebuild(true);
    });

    addMediaChangeListener(hoverFineMedia, function () {
      queueRebuild(true);
    });

    addMediaChangeListener(coarseMedia, function () {
      queueRebuild(true);
    });

    addMediaChangeListener(noHoverMedia, function () {
      queueRebuild(true);
    });

    addMediaChangeListener(reduceMotion, function () {
      queueRebuild(false);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAnimation();
        clearResume();
        return;
      }

      scheduleResume(isTouchAutoplayMode() ? 1300 : 900);
    });

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener(
          'load',
          function () {
            queueRebuild(true);
          },
          { once: true }
        );
      }
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(function () {
        queueRebuild(true);
      });
      observer.observe(container);
    }

    rebuildTrack(false);

    if (shouldAutoplayNow()) {
      startAnimation();
    }
  }

  function initWhenVisible(container) {
    if (!container || container.dataset.hsInit === 'true') return;

    if (!('IntersectionObserver' in window)) {
      initHoverSlideshowGallery(container);
      return;
    }

    if (container.dataset.hsObserved === 'true') return;
    container.dataset.hsObserved = 'true';

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
        observer.unobserve(entry.target);
        initHoverSlideshowGallery(entry.target);
      });
    }, {
      rootMargin: '300px 0px'
    });

    observer.observe(container);
  }

  function initAllHoverSlideshowGalleries(scope) {
    const root = scope || document;

    root
      .querySelectorAll('[data-section-type="hover-slideshow-gallery"]')
      .forEach(function (container) {
        initWhenVisible(container);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHoverSlideshowGalleries(document);
    });
  } else {
    initAllHoverSlideshowGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHoverSlideshowGalleries(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAllHoverSlideshowGalleries(event.target);
  });
})();